module.exports = __webpack_public_path__ + "img/lw.6368a8a8.png";